/**
 *  @fileOverview Experience module, initalises modifiers to World Ready Experience elements
 *
 *  @author       Chris Hill
 *
 */

function ExperienceModule () {
  /**
   * @description Initialises World Ready Experience checks.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    /**
     * Check for empty experince panel and remove
     */
    const experience = document.querySelector('[data-js-world-ready="experience"]')
    let remove = false

    if (experience !== null) {
      console.log('experience is found')
      const facilities = experience.querySelector('[data-js-world-ready="facilities"]')
      const expenses = experience.querySelector('[data-js-world-ready="expenses"]')
      const articles = experience.querySelector('[data-js-world-ready="articles"]')
      const explore = experience.querySelector('[data-js-world-ready="explore"]')

      if (facilities === null && expenses === null && articles === null && explore === null) {
        remove = true
      }

      if (remove) {
        experience.remove()
        const expnav = document.querySelector('a[href="#experience"]')

        if (expnav !== null) {
          expnav.parentNode.remove()
        }
      }
    }
  }
}

module.exports = ExperienceModule
